import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'emm-menu-search',
  templateUrl: './menu-search.component.html',
  styleUrl: './menu-search.component.scss'
})
export class MenuSearchComponent {

    @Output() searchButtonClicked = new EventEmitter<void>();
    @Output() clearSearchButtonClicked = new EventEmitter<void>();

    searchFilter = '';

    handleSearchButtonClicked() {
        this.searchButtonClicked.next();
    }

    handleClearSearchButtonClicked() {
        this.clearSearchButtonClicked.next();
    }
}
